import React, { useCallback, useEffect, useRef } from 'react';

import GifPicker from 'Shared/components/GifPicker/GifPicker';
import { createFormField } from 'Shared/utils/createFormField';

import './index.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  value: {
    fixed_width: {
      url: string;
    };
  };
  onChange: Function;
  searchStr?: string;
  searchInput?: boolean;
  onBlur?: Function;
  onFocus?: Function;
  clearOnSearch?: boolean;
};

function BaseGifPicker({
  value: gif,
  onChange,
  onFocus,
  onBlur,
  searchStr,
  searchInput,
  clearOnSearch = false,
}: Props) {
  const ref = useRef('');
  const handleRemoveGif = useCallback(() => onChange(null), [onChange]);

  useEffect(() => {
    if (clearOnSearch && searchStr !== ref.current) {
      onChange(null);
    }
    ref.current = searchStr;
  }, [searchStr]);

  return (
    <div className="recognition-modal-gif-picker d-flex flex-column">
      {gif && gif.fixed_width?.url ? (
        <div className="recognition-modal-gif-picker-preview d-flex align-items-center justify-content-center border position-relative">
          <img src={gif.fixed_width.url} alt={gif.fixed_width.url} className="w-100 h-100" />
          <span
            className="recognition-modal-gif-picker-preview-close text-danger position-absolute cursor-pointer"
            onClick={handleRemoveGif}
          >
            <WpIcon name="trash" />
          </span>
        </div>
      ) : (
        <GifPicker
          onGifClick={onChange}
          searchStr={searchStr}
          searchInput={searchInput}
          searchInputClassName="recognition-modal-gif-picker-search mb-3"
          onFocus={onFocus}
          onBlur={onBlur}
        />
      )}
    </div>
  );
}

export default createFormField(BaseGifPicker);
